export default __webpack_public_path__ + "static/media/querelle_detail3.5e37483b.jpg";